import { render, staticRenderFns } from "./the-profile-menu-card.vue?vue&type=template&id=81be76c0"
import script from "./the-profile-menu-card.vue?vue&type=script&lang=js"
export * from "./the-profile-menu-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports